'use client';

import { Button, Divider } from '@heroui/react';
import Link from 'next/link';
import type { SubmitEvent } from 'react';
import { useAuth } from '@/hooks/use-auth';
import { cn } from '@/lib/utils';
import { APP_ROUTES } from '@/shared/constants/app-routes';
import { AuthForm } from '../../../components/form/auth-form';

export default function LoginForm() {
	const { getLoginUrl, isLoading } = useAuth();

	const handleSubmit = async (e: SubmitEvent<HTMLFormElement>) => {
		e.preventDefault();

		await getLoginUrl();
	};

	return (
		<AuthForm.Root className={cn('size-auto mx-auto w-full max-w-xl rounded-2xl p-8', 'bg-background shadow-sm')}>
			<AuthForm.Title className="text-2xl">Olá, estamos felizes de te ver por aqui</AuthForm.Title>

			<AuthForm.Form className="flex items-center justify-center gap-4 md:flex-row flex-col" onSubmit={handleSubmit}>
				<Button type="submit" isLoading={isLoading} variant="solid" className="md:w-auto w-full bg-foreground text-background">
					Acessar o meu Clube
				</Button>

				<Button
					type="button"
					as={Link}
					href={APP_ROUTES.PUBLIC.REGISTER}
					variant="solid"
					className="md:w-auto w-full bg-foreground text-background"
				>
					Cadastre-se agora
				</Button>
			</AuthForm.Form>

			<Divider className="bg-clube-gold sm:w-4/6" />

			<div className="w-full space-y-1">
				<AuthForm.Paragraph>Portal exclusivo para profissionais convidados.</AuthForm.Paragraph>
				<AuthForm.Paragraph className="lg:text-base">
					Dúvidas? Clique{' '}
					<Link href={APP_ROUTES.EXTERNAL.SUPPORT} target="_blank" rel="noopener noreferrer" className="underline">
						aqui
					</Link>{' '}
					e entre em contato com nosso suporte.
				</AuthForm.Paragraph>
			</div>
		</AuthForm.Root>
	);
}
